<template>
	<!-- 财务审核 -->
	<div class="billOperationRecord public_Spacing financial-audit-page">
		<div class="pulbic_oparetionBlock financial-audit-filter-panel">
			<div class="audit-filter-head">
				<div>
					<div class="audit-filter-title">筛选条件</div>
					<div class="audit-filter-subtitle">按申请人、申请类型、审核状态和时间范围查询财务审核记录</div>
				</div>
				<div class="audit-filter-current-range">{{ date[0] || '--' }} 至 {{ date[1] || '--' }}</div>
			</div>
			<div class="audit-filter-body">
				<div class="public_criteriaRange audit-filter-controls">
					<div class="public_oparetionBlock_Menu audit-filter-item">
						<label class="public_lbSty">申请人</label>
						<el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择"
							filterable>
							<el-option v-for="(item, index) in customerOptions" :key="index" :label="item.ORMTB421CA06"
								:value="item.ORMTB421CA08">
							</el-option>
						</el-select>
					</div>
					<div class="public_oparetionBlock_Menu audit-filter-item">
						<label class="public_lbSty">申请类型</label>
						<el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
							filterable>
							<el-option v-for="item in materielOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="public_oparetionBlock_Menu audit-filter-item">
						<label class="public_lbSty">审核状态</label>
						<el-select class="public_optionSty dropDown_Define" v-model="ORMTB421CA14" placeholder="请选择">
							<el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="public_operatArea audit-time-controls">
					<div class="audit-date-shortcuts">
						<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive ? 'public_dateActive' : ''"
							@click="getNowDay">当日</span>
						<span class="public_operatArea_yesterday pulic_cursor"
							:class="dateYesterdayActive ? 'public_dateActive' : ''" @click="getYesterday">昨天</span>
						<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive ? 'public_dateActive' : ''"
							@click="sameMonth">当月</span>
						<span class="public_operatArea_yesterday pulic_cursor"
							:class="dateLastMonthActive ? 'public_dateActive' : ''" @click="lastMonth">上月</span>
					</div>
					<div class="public_operatArea_timePicker pulic_cursor audit-date-picker-wrap">
						<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
							:picker-options="startDateDisabled" @change="datePickerChange" start-placeholder="开始日"
							end-placeholder="结束日" class="pulic_cursor audit-date-picker">
						</el-date-picker>
					</div>
					<div class="public_operatBtn audit-action-controls">
						<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist"
							id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
						<button class="public_saleWater_daochu pulic_cursor" @click="exports" v-shiroHiden="solelist"
							id="导出"><i class="iconfont icon-daochu"></i>导出</button>
					</div>
				</div>
			</div>
		</div>
		<div class="billOperationRecord-table pulbic_table_container financial-audit-table">
			<div class="audit-table-head">
				<div class="audit-table-title-row">
					<span class="audit-table-icon">流</span>
					<div>
						<div class="audit-table-title">申请流水</div>
						<div class="audit-table-subtitle">共 {{ pagingPageMo || 0 }} 条申请记录，当前页 {{ tableData.length }} 条</div>
					</div>
				</div>
				<div class="audit-table-tools">
					<div class="audit-status-legend">
						<span><i class="audit-dot audit-dot-pending"></i>审核中</span>
						<span><i class="audit-dot audit-dot-pass"></i>通过</span>
						<span><i class="audit-dot audit-dot-reject"></i>拒绝</span>
					</div>
					<div class="audit-table-date">{{ date[0] || '--' }} 至 {{ date[1] || '--' }}</div>
				</div>
			</div>
				<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;" max-height="90%" stripe highlight-current-row
					:default-sort="{ prop: 'waterNum', order: 'descending' }"
					:header-cell-style="{ color: 'rgba(28,43,55,1)', background: 'rgba(232,246,255,1)', 'font-size': '18px', 'font-weight': '800', 'white-space': 'nowrap', 'line-height': '1.35', 'padding': '11px 0' }" class="public_tableColumn audit-main-table">
					<el-table-column prop="ORMTB421CA06" label="申请人" min-width="104" show-overflow-tooltip>
						<template slot-scope="scope">
							<div class="audit-applicant-cell">
								<span class="audit-avatar">{{ (scope.row.ORMTB421CA06 || '-').slice(0, 1) }}</span>
								<div class="audit-applicant-info">
									<div class="audit-applicant-name">{{ scope.row.ORMTB421CA06 || '--' }}</div>
									<div class="audit-applicant-sub">{{ scope.row.ORMTB421CA99 || '--' }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="ORMTB421CA07" label="申请人类型" width="72">
						<template slot-scope="scope">
							<span class="audit-type-tag">{{ scope.row.ORMTB421CA07 || '--' }}</span>
						</template>
					</el-table-column> -->
					<el-table-column prop="ORMTB421CA20" label="提现类型" min-width="92">
						<template slot-scope="scope">
							<span class="audit-withdraw-tag" v-if="scope.row.ORMTB421CA20 == 0">人工审核</span>
							<span class="audit-withdraw-tag audit-withdraw-origin" v-if="scope.row.ORMTB421CA20 == 1">原路退回</span>
							<span class="audit-withdraw-tag audit-withdraw-freight" v-if="scope.row.ORMTB421CA20 == 2">运费提现</span>
							<span class="audit-muted" v-if="scope.row.ORMTB421CA20 != 0 && scope.row.ORMTB421CA20 != 1 && scope.row.ORMTB421CA20 != 2">--</span>
						</template>
					</el-table-column>
					<el-table-column v-for='(item, index) in tableHeadList'
						:prop="item.prop" :label="item.label" :key="index" :min-width="item.width" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="item.prop === 'ORMTB421CA14'" class="audit-status-tag" :class="{
								'audit-status-pending': scope.row[item.prop] == '审核中',
								'audit-status-pass': scope.row[item.prop] == '通过',
								'audit-status-reject': scope.row[item.prop] == '拒绝'
							}">{{ scope.row[item.prop] || '--' }}</span>
							<span v-else-if="item.prop === 'ORMTB421CA02' || item.prop === 'ORMTB410CB20' || item.prop === 'ORMTB421CA98' || item.prop === 'ORMTB410CA07'" class="audit-money-text">{{ scope.row[item.prop] || 0 }}</span>
							<span v-else>{{ scope.row[item.prop] || '--' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="150">
						<template slot-scope="scope">
							<div class="audit-action-group">
								<el-button class="audit-action-btn audit-action-audit"
									v-if="(scope.row.ORMTB421CA00 == '提现' || scope.row.ORMTB421CA00 == '回款') && scope.row.ORMTB421CA14 == '审核中'"
									type="primary" size="small" @click="isorderAudit(scope.row)" v-shiroHiden="solelist"
									id="审核">审核</el-button>
								<el-button class="audit-action-btn audit-action-detail" type="primary"
									v-if="scope.row.ORMTB421CA00 == '提现' || scope.row.ORMTB421CA00 == '回款'" size="small"
									@click="DetailsClick(scope.row)">详情</el-button>
								<el-button class="audit-action-btn audit-action-export" type="primary" size="small"
									v-if="scope.row.ORMTB421CA25 && scope.row.ORMTB421CA25 > 0"
									@click="refundClick(scope.row)" v-shiroHiden="solelist" id="导出退款明细">导出明细</el-button>
							</div>
						</template>
					</el-table-column>
					<template slot="empty">
						<div class="audit-empty">
							<div class="audit-empty-title">暂无财务审核数据</div>
							<div class="audit-empty-desc">可调整筛选条件或时间范围后重新查询</div>
						</div>
					</template>
				</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>
		<!-- 提现 -->
		<div class="public-dialog">
			<el-dialog title="提现详情" :visible.sync="oerderDetilsShow" width="45%" @close="detailsList = ''"
				:closeOnClickModal='false' append-to-body custom-class="financial-audit-dialog">
				<div class="fa-audit-panel">
					<div class="fa-audit-grid">
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请时间</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA05 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请人</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA06 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请人类型</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA07 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">提现类型</div>
							<div class="fa-audit-value">
								<span v-if="detailsList.ORMTB421CA20 == 0">人工审核</span>
								<span v-if="detailsList.ORMTB421CA20 == 1">原路退回</span>
							</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">到账类型</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA11 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">账号</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA12 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">收款人</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA13 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请备注</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA04 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">审核备注</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA18 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">审核人</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA17 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">审核时间</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA16 || '--' }}</div>
						</div>
					</div>
					<div class="fa-audit-amount-row">
						<div class="fa-audit-amount-item fa-audit-amount-item--highlight">
							<div class="fa-audit-amount-label">申请提现金额</div>
							<div class="fa-audit-amount-value fa-audit-amount-value--primary">{{ detailsList.ORMTB421CA02 || 0 }}</div>
						</div>
						<div class="fa-audit-amount-item">
							<div class="fa-audit-amount-label">手续费</div>
							<div class="fa-audit-amount-value">{{ detailsList.sxf || 0 }}</div>
						</div>
						<div class="fa-audit-amount-item fa-audit-amount-item--highlight">
							<div class="fa-audit-amount-label">实际打款</div>
							<div class="fa-audit-amount-value fa-audit-amount-value--green">{{ detailsList.dk || 0 }}</div>
						</div>
					</div>
					<div class="fa-audit-voucher" v-if="DetailsWaterurl && DetailsWaterurl.length">
						<div class="fa-audit-upload-label">凭证记录</div>
						<div class="fa-audit-voucher-images">
							<el-image v-for="(items, indexs) in DetailsWaterurl" :key="indexs"
								style="width: 80px; height: 80px; border-radius: 8px;" :src="items.url"
								:preview-src-list="DetailsWatersrcList">
							</el-image>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="提现审核" :visible.sync="isorderAuditShow"
				@close="detailsList = '', isorderAuditText = '', imageUrl = ''" width="50%" :closeOnClickModal='false' append-to-body custom-class="financial-audit-dialog">
				<div class="fa-audit-panel">
					<!-- 基本信息 -->
					<div class="fa-audit-grid">
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请时间</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA05 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请人</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA06 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请人类型</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA07 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">提现类型</div>
							<div class="fa-audit-value">
								<span v-if="detailsList.ORMTB421CA20 == 0">人工审核</span>
								<span v-if="detailsList.ORMTB421CA20 == 1">原路退回</span>
							</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">到账类型</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA11 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">账号</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA12 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">收款人</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA13 || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">DM取现余额</div>
							<div class="fa-audit-value">{{ detailsList.dm || '--' }}</div>
						</div>
						<div class="fa-audit-item">
							<div class="fa-audit-label">申请备注</div>
							<div class="fa-audit-value">{{ detailsList.ORMTB421CA04 || '--' }}</div>
						</div>
					</div>
					<!-- 金额信息 -->
					<div class="fa-audit-amount-row">
						<div class="fa-audit-amount-item">
							<div class="fa-audit-amount-label">可提现金额</div>
							<div class="fa-audit-amount-value">{{ detailsList.ORMTB421CA98 || 0 }}</div>
						</div>
						<div class="fa-audit-amount-item fa-audit-amount-item--highlight">
							<div class="fa-audit-amount-label">申请提现金额</div>
							<div class="fa-audit-amount-value fa-audit-amount-value--primary">{{ detailsList.ORMTB421CA02 || 0 }}</div>
						</div>
						<div class="fa-audit-amount-item">
							<div class="fa-audit-amount-label">手续费</div>
							<div class="fa-audit-amount-value">{{ detailsList.sxf || 0 }}</div>
						</div>
						<div class="fa-audit-amount-item fa-audit-amount-item--highlight">
							<div class="fa-audit-amount-label">实际打款</div>
							<div class="fa-audit-amount-value fa-audit-amount-value--green">{{ detailsList.dk || 0 }}</div>
						</div>
					</div>
					<!-- 审核输入 -->
					<div class="fa-audit-input-group">
						<div class="fa-audit-input-item">
							<div class="fa-audit-input-label">审核备注</div>
							<input class="fa-audit-input" type="text" v-model="isorderAuditText" maxlength="20" placeholder="请输入审核备注">
						</div>
						<div class="fa-audit-input-item">
							<div class="fa-audit-input-label">实际提现金额</div>
							<input class="fa-audit-input" type="text" v-model="sjtxje" maxlength="20" placeholder="请输入实际提现金额">
						</div>
						<div class="fa-audit-input-item">
							<div class="fa-audit-input-label">实际提现备注</div>
							<input class="fa-audit-input" type="text" v-model="sjtxjenotes" maxlength="20" placeholder="请输入实际提现备注">
						</div>
					</div>
					<!-- 上传凭证 -->
					<div class="fa-audit-upload">
						<div class="fa-audit-upload-label">上传提现凭证</div>
						<el-upload class="avatar-uploader" action="#" :auto-upload="false" :on-change="handleChangeAdd"
							list-type="picture-card" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
							<i class="el-icon-plus"></i>
						</el-upload>
					</div>
					<!-- 操作按钮 -->
					<div class="fa-audit-actions">
						<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
						<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 充值 -->
		<!-- <div class="public-dialog">
			<el-dialog title="充值详情" :visible.sync="oerderDetilsShow" width="35%" @close="detailsList=''"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值金额</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}</div>
					</div>
					<div class="DWD-li" style="height: 80px">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;">充值记录</div>
						<el-image
						    style="width: 80px; height: 80px"
						    :src="DetailsWaterurl" 
						    :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CC00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CE00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CD01||''}}</div>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="充值审核" :visible.sync="isorderAuditShow" @close="detailsList='',isorderAuditText=''" width="30%"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值金额</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}</div>
					</div>
					<div class="DWD-li" style="height: 80px">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;">充值记录</div>
						<el-image
						    style="width: 80px; height: 80px"
						    :src="DetailsWaterurl" 
						    :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核说明</div>
						<div class="DWD-li-text">
							<input  type="text" v-model="isorderAuditText" maxlength="20" >
						</div>
					</div>
					
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div> -->
		<!--  -->
	</div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
export default {
  mixins: [customerSearchMixin],
	data() {
		return {
			isorderAuditText: '',
			sjtxje: '',
			sjtxjenotes: '',
			ORMTB421ID: '',
			oerderDetilsShow: false,
			isorderAuditShow: false,
			uobj: this.$store.state.uobj, //登陆缓存--用户信息
			date: [], //日期
			dateNowDayActive: false,
			dateYesterdayActive: false,
			dateNowMonthActive: false,
			dateLastMonthActive: false,
			tableData: [],
			materialOptions: [],
			materialTypeValue: '',
			customerOptions: [],
			carNum: '',
			materielMo: '',
			materielOptions: [{
				value: '',
				label: '全部',
			}, {
				value: 'TX',
				label: '提现',
			},
			{
				value: 'HK',
				label: '回款',
			}
			],
			// 状态
			dataStatusOperation: [{
				value: '',
				label: '全部',
			}, {
				value: '0',
				label: '审核中',
			}, {
				value: '1',
				label: '通过',
			}, {
				value: '2',
				label: '拒绝',
			}],
			// 查询
			customerMo: '', //客户--查询		
			ORMTB421CA14: '', //数据状态
			billOperationAdd: false,
			pageMo: 1, //默认列表页码
			limitMo: 10, //每页的条数
			pagingPageMo: 0, //分页--数据列表共有的条数
			currentPage: 1, //设置当前页默认为1
			tableHeadList: [
				{
					prop: 'ORMTB421CA00',
					label: '申请类型',
					width: 70,
				},
				{
					prop: 'ORMTB421CA02',
					label: '金额',
					width: 68,
				},
				{
					prop: 'ORMTB410CB20',
					label: '运费可提现',
					width: 106,
				},
				{
					prop: 'ORMTB421CA98',
					label: '充值可提现',
					width: 106,
				},
				{
					prop: 'ORMTB410CA07',
					label: '能源金可提现',
					width: 106,
				},
				{
					prop: 'ORMTB421CA14',
					label: '审核状态',
					width: 78,
				},
				{
					prop: 'ORMTB421CA16',
					label: '审核时间',
					width: 104,
				},
				{
					prop: 'ORMTB421CA17',
					label: '审核人',
					width: 68,
				},
			],
			// 审核
			imageUrl: '',
			// 详情
			billOperationDetails: false,
			detailsList: '', //详情列表
			isRefresh: true,
			isRefreshSetInterval: '',
			// quanpDisabled: false,
			// 历史缓存
			currentUrl: this.$route.path,
			historyInfo: '',
			// 时间限制
			// 限制开始日期不能超过当前日期
			startDateDisabled: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			},
			solelist: [],
			DetailsWaterurl: '',
			DetailsWatersrcList: []
		}
	},
	created() {
		var list = "";
		list = this.$store.state.solelist;
		// 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
		sessionStorage.removeItem(this.currentUrl)
		if (this.historyInfo != null && this.historyInfo != '') {
			this.init()
		} else {
			this.getNowDay();
		}
		var path = this.$route.path;
		if (path === '/SalesDispatchManagement') {
			path = '/Home' + path
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
	},
	mounted() {
		this.enterprise0ptions()
		this.pageList()
	},
	// 存储数据
	beforeDestroy() {
		var obj = {
			startTime: [this.date[0], this.date[1]], //开始时间
			customerMo: this.customerMo, //申请人
			materielMo: this.materielMo, //申请类型
			ORMTB421CA14: this.ORMTB421CA14, //审核状态
			currentPage: this.currentPage, //当前页数
			pageMo: this.pageMo, //页码
			limitMo: this.limitMo, //每页条数
			dateNowDayActive: this.dateNowDayActive,
			dateYesterdayActive: this.dateYesterdayActive,
			dateNowMonthActive: this.dateNowMonthActive,
			dateLastMonthActive: this.dateLastMonthActive,
		}
		sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
	},
	methods: {
		//初始化数据
		init() {
			this.date = this.historyInfo.startTime
			this.customerMo = this.historyInfo.customerMo
			this.materielMo = this.historyInfo.materielMo
			this.ORMTB421CA14 = this.historyInfo.ORMTB421CA14
			this.currentPage = this.historyInfo.currentPage
			this.pageMo = this.historyInfo.pageMo
			this.limitMo = this.historyInfo.limitMo
			this.dateNowDayActive = this.historyInfo.dateNowDayActive
			this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
			this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
			this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
		},
		// 上传图片
		handleChangeAdd(file, image) {
			this.imageUrl = image;
			// console.log(this.imageUrl)
		},
		// 导出退款明细
		refundClick(row){
			var url = `https://feishazoushi.cn/api/orm/ormtb422/exportDetail?sqr=${row.ORMTB421CA06}&&ORMTB421ID=${row.
ORMTB421ID}`
			window.location.href = url;
		},
		// 导出
		exports() {
			var startTime = this.date[0]; //开始时间
			var endTime = this.date[1]; //结束时间
			var ORMTB421CA08 = this.customerMo; //二级客户ID
			var ORMTB421CA00 = this.materielMo; //物料ID
			var ORMTB421CA14 = this.ORMTB421CA14; //状态
			var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb421toExcle?startTime=" + startTime + "&endTime=" +
				endTime + "&ORMTB421CA08=" + ORMTB421CA08 + "&ORMTB421CA00=" + ORMTB421CA00 + "&ORMTB421CA14=" + ORMTB421CA14;
			window.location.href = url;
		},
		// 申请人--查询
		enterprise0ptions() {
			var List = [{
				ORMTB421CA08: '',
				ORMTB421CA06: '全部',
			}];
			var url = "/orm/ormtb421/selectOrmtb421CA06List";
			this.axios.post(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.customerOptions = [...List, ...res.data.data];
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			})
		},
		// 查询
		queryClick() {
			this.pageList()
		},
		// 列表
		pageList() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				startTime: this.date[0], //开始时间
				endTime: this.date[1], //结束时间
				ORMTB421CA08: this.customerMo, //申请人ID
				// ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
				ORMTB421CA00: this.materielMo, //物料ID
				ORMTB421CA14: this.ORMTB421CA14, //状态
				page: this.pageMo,
				limit: this.limitMo
			}
			this.tableData = [];
			var url = "/orm/ormtb421/selectOrmtb421PageList";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					var data = res.data.data;
					this.tableData = data;
					this.pagingPageMo = res.data.count;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		// 详情
		DetailsClick(row) {
			this.oerderDetilsShow = true;
			this.querydetileTX(row)
		},
		isorderAudit(row) {
			this.isorderAuditShow = true
			this.ORMTB421ID = row.ORMTB421ID
			this.querydetileTX(row)
		},
		isorderAuditServe(type) {
			if (type == 2) {
				if (this.isorderAuditText.trim().length == 0) return this.$message.error('请填写审核备注')
			}
			// console.log(this.imageUrl)
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var formdata = new FormData()
			formdata.append('ORMTB421CA14', type)
			formdata.append('ORMTB421CA08', this.detailsList.ORMTB421CA08)
			formdata.append('ORMTB421CA02', this.detailsList.ORMTB421CA02)
			formdata.append('ORMTB421CA09', this.detailsList.ORMTB421CA06)
			formdata.append('ORMTB421ID', this.ORMTB421ID)
			formdata.append('ORMTB421CA18', this.isorderAuditText)
			formdata.append('ORMTB421CA21', this.sjtxje)
			formdata.append('ORMTB421CA22', this.sjtxjenotes)
			if (this.imageUrl != '') {
				this.imageUrl.forEach(item => {
					formdata.append('file', item.raw)
				})
			} else {
				formdata.append('file', '')
			}
			this.tableData = [];
			if (this.detailsList.ORMTB421CA07 == '司机') {
				var url = "/orm/ormtb421/examine";
			} else {
				var url = "/orm/ormtb421/examineOrmtb410";
			}
			this.axios.post(url, formdata, {
				headers: {
					"Content-Type": "multipart/form-data",
				}
			}).then(res => {
				// console.log(res)
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					this.$message({
						message: '审核成功',
						type: 'success'
					});
					this.isorderAuditShow = false
					this.pageList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		// 提现详情
		querydetileTX(row) {
			var postData = {
				ORMTB421ID: row.ORMTB421ID, //id
			}
			this.detailsList = ''
			var url = "/orm/ormtb421/selectOrmtb421ById";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.detailsList = res.data.data;
					console.log(this.detailsList)
					if (this.detailsList.ORMTB421CA19 != '') {
						this.detailsList.ORMTB421CA19.forEach(item => {
							this.DetailsWatersrcList.push(item.url)
							console.log(item.url)
						})
						this.DetailsWaterurl = this.detailsList.ORMTB421CA19
					} else {
						this.DetailsWatersrcList = []
						this.DetailsWaterurl = ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}

			})
		},
		//获取当前时间
		getNowDay() {
			var date = new Date().getTime();
			var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
			this.date = [nowDay, nowDay];
			this.dateNowDayActive = true
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		datePickerChange(e) {
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取昨天时间
		getYesterday() {
			var hms = new Date().getTime() - 86400000;
			var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
			this.date = [nowDay, nowDay];
			this.dateNowDayActive = false
			this.dateYesterdayActive = true
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取当月时间
		sameMonth() {
			var date = new Date();
			var hms = date.setDate(1);
			var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
			var nextdate = new Date().getTime();
			var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
			this.date = [firstDay, nextDay];
			this.startTime = this.date[0];
			this.endTime = this.date[1];
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = true
			this.dateLastMonthActive = false
		},
		//获取上月时间
		lastMonth() {
			var nowdays = new Date();
			var year = nowdays.getFullYear();
			var month = nowdays.getMonth();
			if (month == 0) {
				month = 12;
				year = year - 1;
			}
			if (month < 10) {
				month = "0" + month;
			}
			var firstDayOfPreMonth = year + "-" + month + "-" + "01";
			var lastDay = new Date(year, month, 0);
			let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
			this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = true
		},
		handleSizeChange(val) {
			this.pageMo = 1
			this.limitMo = val;
			this.pageList();
		},
		// 点击页码
		handleCurrentChange(val) {
			this.pageMo = val;
			this.pageList();
		},
	}
}
</script>

<style scoped>

.financial-audit-page {
	min-height: 100%;
	background:
		linear-gradient(180deg, #edf4ff 0%, #f5f8fc 44%, #f7f9fc 100%);
}

.financial-audit-header {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 18px;
	margin-bottom: 16px;
	padding: 20px 24px;
	overflow: hidden;
	border: 1px solid rgba(210, 224, 245, 0.88);
	border-radius: 20px;
	background:
		radial-gradient(circle at 86% 12%, rgba(64, 158, 255, 0.18), transparent 30%),
		linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(236, 246, 255, 0.94));
	box-shadow: 0 16px 42px rgba(35, 69, 113, 0.09);
}

.financial-audit-header::before {
	position: absolute;
	top: -36px;
	right: 180px;
	width: 150px;
	height: 150px;
	content: '';
	border-radius: 50%;
	background: rgba(102, 177, 255, 0.1);
}

.financial-audit-title {
	position: relative;
	font-size: 24px;
	font-weight: 700;
	line-height: 1.35;
	letter-spacing: 1px;
	color: #1b2d45;
}

.financial-audit-subtitle {
	position: relative;
	margin-top: 6px;
	font-size: 13px;
	line-height: 1.6;
	color: #6b7c8f;
}

.financial-audit-badges {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
	gap: 8px;
}

.financial-audit-badges span {
	display: inline-flex;
	align-items: center;
	height: 30px;
	padding: 0 14px;
	font-size: 13px;
	font-weight: 600;
	color: #2470be;
	white-space: nowrap;
	border: 1px solid rgba(64, 158, 255, 0.2);
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.82);
}

.financial-audit-filter-panel {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	box-sizing: border-box;
	margin-bottom: 16px;
	padding: 16px 18px;
	border: 1px solid #e6edf7;
	border-radius: 18px;
	background: linear-gradient(135deg, #f9fbff, #f4f9ff);
	box-shadow: 0 10px 24px rgba(46, 89, 132, .05);
}

.financial-audit-filter-panel .public_criteriaRange,
.financial-audit-filter-panel .public_operatArea {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
}

.financial-audit-filter-panel .public_oparetionBlock_Menu {
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 220px;
}

.financial-audit-filter-panel .public_oparetionBlock_Menu .public_lbSty {
	width: auto;
	margin: 0;
	font-size: 13px;
	font-weight: 600;
	color: #52616f;
	white-space: nowrap;
}

.financial-audit-filter-panel .public_oparetionBlock_Menu >>> .el-select {
	width: 190px;
}

.financial-audit-filter-panel .public_operatArea_timePicker >>> .el-date-editor {
	width: 260px;
}

.financial-audit-filter-panel .public_operatBtn {
	display: flex;
	align-items: center;
	gap: 10px;
}

.financial-audit-filter-panel .public_saleWater_chaxun,
.financial-audit-filter-panel .public_saleWater_daochu {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 36px;
	padding: 0 16px;
	border-radius: 999px;
	font-size: 13px;
	font-weight: 600;
	box-shadow: 0 8px 16px rgba(64, 158, 255, 0.18);
}

.financial-audit-table {
	padding: 0 4px 24px;
}

.financial-audit-table .public_tableColumn {
	border: 0;
	overflow: hidden;
	border-radius: 18px;
	box-shadow: 0 14px 32px rgba(31, 69, 113, 0.08);
}

.financial-audit-table .el-table::before {
	height: 0;
}

.financial-audit-table >>> .el-table__header-wrapper th {
	padding: 12px 0;
	font-size: 13px;
	font-weight: 700;
	color: #24364b;
	background: linear-gradient(180deg, #f8fbff, #edf4fb);
}

.financial-audit-table >>> .el-table__body-wrapper td {
	padding: 10px 0;
	font-size: 13px;
	color: #435569;
}

.financial-audit-table >>> .el-table__body-wrapper tr:hover > td {
	background: #f4f9ff !important;
}

.financial-audit-table >>> .el-button {
	border-radius: 999px;
}

.financial-audit-table >>> .el-pagination {
	padding: 18px 0 6px;
}

.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	box-sizing: border-box;
	border: 1px solid #999;
	font-size: 16px;
	color: #333;
}

.DWD-li>div {
	padding: 0 5px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	width: 130px;
	text-align: center;
	border-right: 1px solid #999;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-li-text {
	flex: 1;
}

.DWD-li-text input {
	width: 100%;
	height: 35px;
	line-height: 35px;
	border: none;
	outline: none;
}

.DWD-li+.DWD-li {
	border-top: none;
}

.DWD-table {
	display: flex;
}

.DWD-table-left-flex {
	flex: 1;
}

.DWD-table>div>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #999;
	border-bottom: 1px solid #999;
	box-sizing: border-box;
}

.DWD-table>div>div:first-child {
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
	width: 101px;
	text-align: center;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	box-sizing: border-box;
	border-left: 1px solid #999;
	border-bottom: 1px solid #999;
}

.DetailsWater-img {
	margin-top: 30px;
}

.DetailsWater-img-text {
	display: inline-block;
	width: 101px;
	text-align: center;
	vertical-align: top;
}

.car-number-add {
	/* text-transform: uppercase; */
}

.billOperationRecord-table {
	padding: 0 4px 24px;
}

.public_singleMenu .pulic_carNumber {
	margin-top: 6px;
	height: 40px;
	line-height: 40px;
	box-sizing: border-box;
	font-size: 14px;
	display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
	background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
	flex: 1.5;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
	margin-top: 6px;
	height: 40px;
	line-height: 40px;
	box-sizing: border-box;
	font-size: 14px;
	display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
	height: 45px;
	align-items: center;
}

.billOperationRecord {
	background: transparent;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center !important;
}

.financial-audit-page .pulic_operatArea_now,
.financial-audit-page .public_operatArea_yesterday {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 58px;
	height: 32px;
	padding: 0 13px;
	font-size: 13px;
	font-weight: 600;
	color: #596a7c;
	border: 1px solid #dfe8f4;
	border-radius: 999px;
	background: #fff;
	transition: all 0.18s ease;
}

.financial-audit-page .pulic_operatArea_now:hover,
.financial-audit-page .public_operatArea_yesterday:hover {
	color: #2470be;
	border-color: rgba(64, 158, 255, 0.42);
	background: #edf6ff;
}

.financial-audit-page .public_dateActive {
	color: #fff !important;
	border-color: transparent !important;
	background: linear-gradient(135deg, #2f89f4, #3db7ff) !important;
	box-shadow: 0 8px 16px rgba(64, 158, 255, 0.26);
}

.financial-audit-page >>> .el-input__inner,
.financial-audit-page >>> .el-date-editor {
	border-color: #dfe8f4;
	border-radius: 10px;
	background: #fff;
}

.financial-audit-page >>> .el-input__inner,
.financial-audit-page >>> .el-range-input {
	font-size: 13px;
}

.financial-audit-page .DWD-li {
	height: auto;
	min-height: 40px;
	line-height: 1.5;
	border: 1px solid #e1ebf6;
	font-size: 14px;
	color: #33465d;
	background: #fff;
}

.financial-audit-page .DWD-li > div {
	display: flex;
	align-items: center;
	height: auto;
	min-height: 39px;
	padding: 8px 12px;
}

.financial-audit-page .DWD-li-title {
	justify-content: center;
	width: 132px;
	font-weight: 700;
	color: #2470be;
	border-right: 1px solid #e1ebf6;
	background: linear-gradient(135deg, #f4f9ff, #edf6ff);
}

.financial-audit-page .DWD-li-text input {
	height: 32px;
	line-height: 32px;
	padding: 0 10px;
	border: 1px solid #dfe8f4;
	border-radius: 8px;
	box-sizing: border-box;
}

.financial-audit-page .DetailsWater-img {
	padding: 16px;
	border: 1px dashed #bdd4ed;
	border-radius: 14px;
	background: #f8fbff;
}

.financial-audit-page .DetailsWater-img-text {
	width: auto;
	margin-right: 14px;
	font-size: 14px;
	font-weight: 700;
	color: #52616f;
}

.financial-audit-page >>> .el-dialog {
	border-radius: 18px;
	overflow: hidden;
}

.financial-audit-page >>> .el-dialog__header {
	padding: 18px 22px;
	background: linear-gradient(135deg, #f7fbff, #edf6ff);
}

.financial-audit-page >>> .el-dialog__title {
	font-size: 17px;
	font-weight: 700;
	color: #24364b;
}

@media screen and (max-width: 1200px) {
	.financial-audit-filter-panel {
		align-items: flex-start;
		flex-direction: column;
	}

	.financial-audit-filter-panel .public_criteriaRange,
	.financial-audit-filter-panel .public_operatArea {
		width: 100%;
	}
}

@media screen and (max-width: 768px) {
	.financial-audit-header {
		align-items: flex-start;
		flex-direction: column;
		padding: 16px;
	}

	.financial-audit-badges {
		justify-content: flex-start;
	}

	.financial-audit-filter-panel {
		padding: 12px;
	}

	.financial-audit-filter-panel .public_oparetionBlock_Menu,
	.financial-audit-filter-panel .public_oparetionBlock_Menu >>> .el-select,
	.financial-audit-filter-panel .public_operatArea_timePicker,
	.financial-audit-filter-panel .public_operatArea_timePicker >>> .el-date-editor,
	.financial-audit-filter-panel .public_operatBtn {
		width: 100%;
	}

	.financial-audit-filter-panel .public_operatBtn button {
		flex: 1;
	}
}
.financial-audit-page .financial-audit-filter-panel {
	display: grid;
	grid-template-columns: minmax(520px, 1fr) minmax(520px, auto);
	align-items: stretch;
	gap: 14px;
	padding: 14px;
	border-color: #dfeaf6;
	background:
		linear-gradient(135deg, rgba(255, 255, 255, .96), rgba(246, 250, 255, .94)),
		repeating-linear-gradient(135deg, rgba(64, 158, 255, .04) 0, rgba(64, 158, 255, .04) 1px, transparent 1px, transparent 18px);
}

.financial-audit-page .audit-filter-controls,
.financial-audit-page .audit-time-controls {
	position: relative;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
	box-sizing: border-box;
	min-width: 0;
	padding: 34px 12px 12px;
	border: 1px solid #e4edf7;
	border-radius: 16px;
	background: rgba(255, 255, 255, .78);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, .86);
}

.financial-audit-page .audit-filter-controls::before,
.financial-audit-page .audit-time-controls::before {
	position: absolute;
	top: 12px;
	left: 14px;
	font-size: 13px;
	font-weight: 800;
	line-height: 1;
	color: #24364b;
	content: '筛选条件';
}

.financial-audit-page .audit-time-controls::before {
	content: '时间范围';
}

.financial-audit-page .audit-time-controls {
	justify-content: flex-end;
	background: linear-gradient(135deg, rgba(247, 251, 255, .92), rgba(255, 255, 255, .82));
}

.financial-audit-page .audit-filter-item {
	display: grid;
	grid-template-columns: auto minmax(150px, 1fr);
	align-items: center;
	gap: 8px;
	min-width: 0;
	height: auto;
	flex: 1 1 190px;
}

.financial-audit-page .audit-filter-item .public_lbSty {
	height: 34px;
	line-height: 34px;
	color: #52616f;
	font-weight: 700;
}

.financial-audit-page .audit-filter-item >>> .el-select,
.financial-audit-page .audit-filter-item >>> .el-input,
.financial-audit-page .audit-filter-item >>> .el-input__inner {
	width: 100%;
}

.financial-audit-page .audit-filter-item >>> .el-input__inner,
.financial-audit-page .audit-time-controls >>> .el-input__inner {
	height: 34px;
	line-height: 34px;
}

.financial-audit-page .audit-time-controls > span {
	height: 34px;
	min-width: 56px;
	padding: 0 14px;
}

.financial-audit-page .audit-time-controls .public_operatArea_timePicker >>> .el-date-editor {
	width: 260px;
	height: 34px;
	line-height: 34px;
}

.financial-audit-page .audit-action-controls {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	margin-left: 2px;
}

.financial-audit-page .audit-action-controls button {
	min-width: 78px;
	height: 34px;
}

@media screen and (max-width: 1280px) {
	.financial-audit-page .financial-audit-filter-panel {
		grid-template-columns: 1fr;
	}

	.financial-audit-page .audit-time-controls {
		justify-content: flex-start;
	}
}

@media screen and (max-width: 768px) {
	.financial-audit-page .audit-filter-controls,
	.financial-audit-page .audit-time-controls {
		padding: 32px 10px 10px;
	}

	.financial-audit-page .audit-filter-item,
	.financial-audit-page .audit-time-controls .public_operatArea_timePicker,
	.financial-audit-page .audit-time-controls .public_operatArea_timePicker >>> .el-date-editor,
	.financial-audit-page .audit-action-controls {
		width: 100%;
	}

	.financial-audit-page .audit-action-controls button {
		flex: 1;
	}
}
.financial-audit-page {
	position: relative;
	box-sizing: border-box;
	padding: 16px;
	background:
		radial-gradient(circle at 88% 4%, rgba(64, 158, 255, .14), transparent 28%),
		radial-gradient(circle at 4% 32%, rgba(32, 201, 151, .1), transparent 24%),
		linear-gradient(180deg, #edf4ff 0%, #f6f9fd 46%, #f8fafc 100%);
}

.financial-audit-page::before {
	position: absolute;
	inset: 0 0 auto 0;
	height: 116px;
	content: '';
	pointer-events: none;
	background: linear-gradient(180deg, rgba(255, 255, 255, .64), rgba(255, 255, 255, 0));
}

.financial-audit-page .financial-audit-filter-panel {
	position: relative;
	z-index: 1;
	margin-bottom: 18px;
	border: 1px solid rgba(204, 221, 240, .92);
	border-radius: 22px;
	box-shadow: 0 16px 36px rgba(36, 75, 118, .1);
}

.financial-audit-page .audit-filter-controls,
.financial-audit-page .audit-time-controls {
	border-color: #dce8f6;
	background:
		linear-gradient(145deg, rgba(255, 255, 255, .94), rgba(247, 251, 255, .88));
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, .92), 0 8px 18px rgba(44, 86, 132, .04);
}

.financial-audit-page .audit-filter-controls::before,
.financial-audit-page .audit-time-controls::before {
	padding-left: 10px;
	border-left: 4px solid #409eff;
}

.financial-audit-page .audit-time-controls::before {
	border-left-color: #20c997;
}

.financial-audit-page .financial-audit-table {
	position: relative;
	z-index: 1;
	box-sizing: border-box;
	padding: 16px;
	border: 1px solid rgba(216, 228, 242, .92);
	border-radius: 22px;
	background:
		linear-gradient(180deg, rgba(255, 255, 255, .98), rgba(247, 251, 255, .96));
	box-shadow: 0 18px 40px rgba(31, 69, 112, .1);
}

.financial-audit-page .financial-audit-table::before {
	display: flex;
	align-items: center;
	height: 34px;
	margin-bottom: 12px;
	padding-left: 12px;
	font-size: 15px;
	font-weight: 800;
	color: #24364b;
	content: '审核记录';
	border-left: 4px solid #409eff;
}

.financial-audit-page .financial-audit-table .public_tableColumn {
	border: 1px solid #e5eef7;
	border-radius: 16px;
	box-shadow: none;
}

.financial-audit-page .financial-audit-table >>> .el-table__header-wrapper th {
	border-bottom: 1px solid #dce8f6;
	background: linear-gradient(180deg, #f7fbff, #eaf3fc) !important;
}

.financial-audit-page .financial-audit-table >>> .el-table__body-wrapper td {
	border-bottom: 1px solid #edf2f8;
}

.financial-audit-page .financial-audit-table .pulbic_pagesize {
	margin-top: 14px;
	padding: 10px 12px;
	border: 1px solid #e4edf7;
	border-radius: 14px;
	background: #f8fbff;
}

.financial-audit-page .financial-audit-table >>> .el-pagination {
	padding: 0;
}

.financial-audit-page .financial-audit-table >>> .public_icon_xiangqing,
.financial-audit-page .financial-audit-table >>> .el-button {
	font-weight: 700;
	box-shadow: 0 6px 14px rgba(64, 158, 255, .16);
}

@media screen and (max-width: 768px) {
	.financial-audit-page {
		padding: 12px;
	}

	.financial-audit-page .financial-audit-table {
		padding: 12px;
	}
}

	.financial-audit-page .audit-table-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 14px;
		margin-bottom: 12px;
	}

	.financial-audit-page .financial-audit-table::before {
		display: none;
	}

	.financial-audit-page .audit-table-title {
		position: relative;
		padding-left: 12px;
		color: #1f3a4a;
		font-size: 18px;
		font-weight: 800;
		line-height: 24px;
	}

	.financial-audit-page .audit-table-title::before {
		position: absolute;
		left: 0;
		top: 5px;
		width: 4px;
		height: 14px;
		content: '';
		border-radius: 4px;
		background: linear-gradient(180deg, #2478e8, #20c997);
	}

	.financial-audit-page .audit-table-subtitle {
		margin-top: 3px;
		padding-left: 12px;
		color: #7b8c98;
		font-size: 12px;
	}

	.financial-audit-page .audit-table-date {
		padding: 8px 12px;
		border-radius: 14px;
		background: #f6fbff;
		color: #607481;
		font-size: 12px;
		font-weight: 700;
		white-space: nowrap;
	}

	.financial-audit-page .audit-applicant-cell {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
		text-align: left;
	}

	.financial-audit-page .audit-avatar {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 26px;
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background: linear-gradient(135deg, #2478e8, #20c997);
		color: #fff;
		font-size: 12px;
		font-weight: 800;
	}

	.financial-audit-page .audit-applicant-info {
		min-width: 0;
	}

	.financial-audit-page .audit-applicant-name {
		color: #304653;
		font-weight: 800;
		line-height: 19px;
	}

	.financial-audit-page .audit-applicant-sub {
		margin-top: 2px;
		color: #8a9aa7;
		font-size: 12px;
		line-height: 16px;
	}

	.financial-audit-page .audit-type-tag,
	.financial-audit-page .audit-withdraw-tag,
	.financial-audit-page .audit-status-tag {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 64px;
		height: 24px;
		padding: 0 8px;
		border-radius: 12px;
		box-sizing: border-box;
		font-size: 12px;
		font-weight: 800;
	}

	.financial-audit-page .audit-type-tag,
	.financial-audit-page .audit-withdraw-tag {
		background: #eef8ff;
		color: #0f7fc5;
	}

	.financial-audit-page .audit-withdraw-origin {
		background: #fff6e8;
		color: #d8840d;
	}

	.financial-audit-page .audit-withdraw-freight {
		background: #ecfbf6;
		color: #159b75;
	}

	.financial-audit-page .audit-status-pending {
		background: #fff6e8;
		color: #d8840d;
	}

	.financial-audit-page .audit-status-pass {
		background: #e9faf4;
		color: #10a777;
	}

	.financial-audit-page .audit-status-reject {
		background: #fff0f0;
		color: #df4d4d;
	}

	.financial-audit-page .audit-money-text {
		color: #0f7fc5;
		font-weight: 800;
	}

	.financial-audit-page .audit-muted {
		color: #9aacb7;
		font-size: 12px;
	}

	.financial-audit-page .audit-action-group {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: nowrap;
		gap: 4px;
	}

	.financial-audit-page .audit-action-group .el-button {
		min-width: 50px;
		padding: 0 9px;
		margin-left: 0;
		border-radius: 8px;
		box-shadow: none;
		font-weight: 800;
	}

	.financial-audit-page .audit-action-audit {
		color: #0f7fc5 !important;
		background: #eef8ff !important;
		border-color: #cbe7f8 !important;
	}

	.financial-audit-page .audit-action-detail {
		color: #159b75 !important;
		background: #ecfbf6 !important;
		border-color: #cde6dc !important;
	}

	.financial-audit-page .audit-action-export {
		color: #d8840d !important;
		background: #fff6e8 !important;
		border-color: #f4ddb7 !important;
	}

	.financial-audit-page .audit-empty {
		padding: 42px 0;
		text-align: center;
	}

	.financial-audit-page .audit-empty-title {
		color: #334955;
		font-size: 16px;
		font-weight: 800;
	}

	.financial-audit-page .audit-empty-desc {
		margin-top: 8px;
		color: #8fa1ad;
		font-size: 13px;
	}

	.financial-audit-page >>> .audit-main-table {
		border-radius: 12px;
		overflow: hidden;
	}

	.financial-audit-page >>> .audit-main-table .el-table__header th {
		height: 46px;
	}

	.financial-audit-page >>> .audit-main-table .el-table__row td {
		height: 56px;
		color: #455a64;
	}

	.financial-audit-page >>> .audit-main-table .el-table__row:hover > td {
		background-color: #f0f9ff !important;
	}

	.financial-audit-page >>> .audit-main-table .el-table__fixed-right::before,
	.financial-audit-page >>> .audit-main-table .el-table__fixed::before {
		height: 0;
	}

	.financial-audit-page >>> .el-dialog__body {
		padding: 22px 24px 26px;
	}

	.financial-audit-page .DetailsWater-Dialog {
		max-height: 68vh;
		overflow-y: auto;
		padding-right: 6px;
	}


	@media screen and (max-width: 768px) {
		.financial-audit-page .audit-table-head {
			align-items: flex-start;
			flex-direction: column;
		}

		.financial-audit-page .audit-table-date {
			white-space: normal;
		}
	}


	.financial-audit-page .financial-audit-filter-panel {
		display: block;
		padding: 16px;
		border: 1px solid rgba(200, 220, 238, .9);
		border-radius: 18px;
		background:
			linear-gradient(135deg, rgba(255, 255, 255, .98), rgba(247, 251, 255, .95)),
			radial-gradient(circle at 100% 0, rgba(64, 158, 255, .12), transparent 34%);
		box-shadow: 0 14px 30px rgba(34, 73, 116, .08);
	}

	.financial-audit-page .audit-filter-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		margin-bottom: 14px;
		padding-bottom: 12px;
		border-bottom: 1px solid #e6eef7;
	}

	.financial-audit-page .audit-filter-title {
		position: relative;
		padding-left: 12px;
		color: #1f3a4a;
		font-size: 18px;
		font-weight: 800;
		line-height: 24px;
	}

	.financial-audit-page .audit-filter-title::before {
		position: absolute;
		left: 0;
		top: 5px;
		width: 4px;
		height: 14px;
		content: '';
		border-radius: 4px;
		background: linear-gradient(180deg, #2478e8, #20c997);
	}

	.financial-audit-page .audit-filter-subtitle {
		margin-top: 3px;
		padding-left: 12px;
		color: #7b8c98;
		font-size: 12px;
	}

	.financial-audit-page .audit-filter-current-range {
		padding: 8px 12px;
		border: 1px solid #dfeaf6;
		border-radius: 14px;
		background: #f6fbff;
		color: #607481;
		font-size: 12px;
		font-weight: 700;
		white-space: nowrap;
	}

	.financial-audit-page .audit-filter-body {
		display: grid;
		grid-template-columns: minmax(420px, 1fr) auto;
		align-items: end;
		gap: 14px;
	}

	.financial-audit-page .audit-filter-controls {
		display: grid;
		grid-template-columns: repeat(3, minmax(150px, 1fr));
		gap: 12px;
		min-width: 0;
		padding: 0;
		border: 0;
		background: transparent;
		box-shadow: none;
	}

	.financial-audit-page .audit-filter-controls::before,
	.financial-audit-page .audit-time-controls::before {
		display: none;
	}

	.financial-audit-page .audit-filter-item {
		display: block;
		min-width: 0;
		height: auto;
		margin: 0;
	}

	.financial-audit-page .audit-filter-item .public_lbSty {
		display: block;
		height: auto;
		margin-bottom: 7px;
		color: #516674;
		font-size: 13px;
		font-weight: 800;
		line-height: 18px;
	}

	.financial-audit-page .audit-filter-item >>> .el-select,
	.financial-audit-page .audit-filter-item >>> .el-input,
	.financial-audit-page .audit-filter-item >>> .el-input__inner {
		width: 100% !important;
	}

	.financial-audit-page .audit-time-controls {
		display: flex;
		align-items: flex-end;
		justify-content: flex-end;
		flex-wrap: wrap;
		gap: 10px;
		min-width: 0;
		padding: 0;
		border: 0;
		background: transparent;
		box-shadow: none;
	}

	.financial-audit-page .audit-date-shortcuts {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
	}

	.financial-audit-page .audit-date-picker-wrap {
		margin: 0;
	}

	.financial-audit-page .audit-date-picker.el-date-editor--daterange.el-input__inner {
		width: 270px;
		height: 36px;
		line-height: 36px;
	}

	.financial-audit-page .audit-action-controls {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		margin-left: 0;
	}

	.financial-audit-page .audit-action-controls button {
		min-width: 82px;
		height: 36px;
		border: 0;
		border-radius: 10px;
		font-weight: 800;
	}

	.financial-audit-page .audit-action-controls .public_saleWater_chaxun {
		background: linear-gradient(135deg, #2478e8, #3db7ff) !important;
		box-shadow: 0 8px 18px rgba(64, 158, 255, .22);
	}

	.financial-audit-page .audit-action-controls .public_saleWater_daochu {
		background: linear-gradient(135deg, #20b486, #20c997) !important;
		box-shadow: 0 8px 18px rgba(32, 201, 151, .2);
	}

	@media screen and (max-width: 1360px) {
		.financial-audit-page .audit-filter-body {
			grid-template-columns: 1fr;
		}

		.financial-audit-page .audit-time-controls {
			justify-content: flex-start;
		}
	}

	@media screen and (max-width: 900px) {
		.financial-audit-page .audit-filter-controls {
			grid-template-columns: 1fr;
		}

		.financial-audit-page .audit-filter-head {
			align-items: flex-start;
			flex-direction: column;
		}

		.financial-audit-page .audit-filter-current-range,
		.financial-audit-page .audit-date-picker-wrap,
		.financial-audit-page .audit-date-picker.el-date-editor--daterange.el-input__inner,
		.financial-audit-page .audit-action-controls {
			width: 100%;
		}

		.financial-audit-page .audit-action-controls button {
			flex: 1;
		}
	}


	.financial-audit-page .financial-audit-table {
		position: relative;
		z-index: 1;
		padding: 16px 16px 0;
		border: 1px solid rgba(204, 221, 240, .92);
		border-radius: 20px;
		background:
			linear-gradient(180deg, rgba(255, 255, 255, .99), rgba(248, 252, 255, .96));
		box-shadow: 0 16px 36px rgba(31, 69, 112, .09);
		box-sizing: border-box;
	}

	.financial-audit-page .financial-audit-table::before {
		display: none;
	}

	.financial-audit-page .audit-table-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 14px;
		margin-bottom: 14px;
		padding-bottom: 13px;
		border-bottom: 1px solid #e5eef7;
	}

	.financial-audit-page .audit-table-title-row,
	.financial-audit-page .audit-table-tools,
	.financial-audit-page .audit-status-legend {
		display: flex;
		align-items: center;
	}

	.financial-audit-page .audit-table-title-row {
		gap: 10px;
	}

	.financial-audit-page .audit-table-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 38px;
		width: 38px;
		height: 38px;
		border-radius: 13px;
		background: linear-gradient(135deg, #2478e8, #20c997);
		box-shadow: 0 10px 18px rgba(64, 158, 255, .2);
		color: #fff;
		font-size: 15px;
		font-weight: 800;
	}

	.financial-audit-page .audit-table-title {
		padding-left: 0;
		color: #1f3a4a;
		font-size: 18px;
		font-weight: 800;
		line-height: 24px;
	}

	.financial-audit-page .audit-table-title::before {
		display: none;
	}

	.financial-audit-page .audit-table-subtitle {
		margin-top: 3px;
		padding-left: 0;
		color: #7b8c98;
		font-size: 12px;
	}

	.financial-audit-page .audit-table-tools {
		justify-content: flex-end;
		flex-wrap: wrap;
		gap: 10px;
	}

	.financial-audit-page .audit-status-legend {
		gap: 12px;
		padding: 8px 12px;
		border-radius: 14px;
		background: #f6fbff;
		color: #607481;
		font-size: 12px;
		font-weight: 700;
	}

	.financial-audit-page .audit-dot {
		display: inline-block;
		width: 7px;
		height: 7px;
		margin-right: 6px;
		border-radius: 50%;
	}

	.financial-audit-page .audit-dot-pending {
		background: #f0a31a;
	}

	.financial-audit-page .audit-dot-pass {
		background: #20b486;
	}

	.financial-audit-page .audit-dot-reject {
		background: #ef6b6b;
	}

	.financial-audit-page .audit-table-date {
		padding: 8px 12px;
		border: 1px solid #e1ebf6;
		border-radius: 14px;
		background: #fff;
		color: #607481;
		font-size: 12px;
		font-weight: 700;
		white-space: nowrap;
	}

	.financial-audit-page .financial-audit-table .public_tableColumn {
		border: 1px solid #e4edf7;
		border-radius: 14px;
		box-shadow: none;
		overflow: hidden;
	}

	.financial-audit-page >>> .audit-main-table .el-table__body-wrapper {
		overflow-x: hidden;
	}

	.financial-audit-page >>> .audit-main-table .el-table__header th .cell {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.financial-audit-page >>> .audit-main-table .el-table__header th {
		height: 48px;
		border-bottom: 1px solid #dce8f6;
		background: linear-gradient(180deg, #f7fbff, #eaf4fc) !important;
	}

	.financial-audit-page >>> .audit-main-table .el-table__header th .cell {
		color: #2d4658;
		font-size: 16px;
		font-weight: 800;
	}

	.financial-audit-page >>> .audit-main-table .el-table__row td {
		height: 58px;
		border-bottom: 1px solid #eef4f9;
		color: #455a64;
	}

	.financial-audit-page >>> .audit-main-table .el-table__row:hover > td {
		background-color: #f0f9ff !important;
	}

	.financial-audit-page .audit-applicant-cell {
		padding-left: 4px;
	}

	.financial-audit-page .audit-avatar {
		box-shadow: 0 8px 15px rgba(36, 120, 232, .2);
	}

	.financial-audit-page .audit-money-text {
		display: inline-block;
		min-width: 70px;
		padding: 4px 9px;
		border-radius: 9px;
		background: #f3fbff;
		color: #0f7fc5;
		font-weight: 800;
	}

	.financial-audit-page .audit-status-tag,
	.financial-audit-page .audit-type-tag,
	.financial-audit-page .audit-withdraw-tag {
		box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .45);
	}

	.financial-audit-page .audit-action-group {
		gap: 8px;
	}

	.financial-audit-page .audit-action-group .el-button {
		min-width: 60px;
		height: 30px;
		padding: 0 10px;
		border-radius: 9px;
		line-height: 28px;
	}

	.financial-audit-page .financial-audit-table .pulbic_pagesize {
		display: flex;
		justify-content: flex-end;
		margin-top: 0;
		padding: 14px 2px 16px;
		border: 0;
		background: transparent;
	}

	.financial-audit-page >>> .audit-main-table .el-table__empty-block {
		min-height: 210px;
	}

	@media screen and (max-width: 900px) {
		.financial-audit-page .audit-table-head {
			align-items: flex-start;
			flex-direction: column;
		}

		.financial-audit-page .audit-table-tools,
		.financial-audit-page .audit-status-legend,
		.financial-audit-page .audit-table-date {
			width: 100%;
		}

		.financial-audit-page .audit-status-legend {
			box-sizing: border-box;
			justify-content: space-between;
		}

		.financial-audit-page .audit-table-date {
			box-sizing: border-box;
			white-space: normal;
		}
	}

</style>

<style>
.financial-audit-dialog {
	border-radius: 18px;
	overflow: hidden;
}

.financial-audit-dialog .el-dialog__header {
	padding: 18px 22px;
	background: linear-gradient(135deg, #f7fbff, #edf6ff);
}

.financial-audit-dialog .el-dialog__title {
	font-size: 17px;
	font-weight: 700;
	color: #24364b;
}

.financial-audit-dialog .el-dialog__body {
	padding: 20px 24px 22px;
}

.fa-audit-panel {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.fa-audit-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
}

.fa-audit-item {
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 10px 12px;
	background: #f4f9ff;
	border: 1px solid #dde9f5;
	border-radius: 10px;
}

.fa-audit-label {
	font-size: 12px;
	font-weight: 600;
	color: #6b8aaa;
}

.fa-audit-value {
	font-size: 14px;
	font-weight: 700;
	color: #0a1e30;
	word-break: break-all;
}

.fa-audit-amount-row {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 10px;
}

.fa-audit-amount-item {
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 12px 14px;
	background: #f4f9ff;
	border: 1px solid #dde9f5;
	border-radius: 10px;
	text-align: center;
}

.fa-audit-amount-item--highlight {
	background: linear-gradient(135deg, #fff8ef, #fff3e0);
	border-color: #f5d9a8;
}

.fa-audit-amount-label {
	font-size: 12px;
	font-weight: 600;
	color: #6b8aaa;
}

.fa-audit-amount-value {
	font-size: 20px;
	font-weight: 800;
	color: #0a1e30;
}

.fa-audit-amount-value--primary { color: #178bff; }
.fa-audit-amount-value--green { color: #08c98a; }

.fa-audit-input-group {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.fa-audit-input-item {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0 12px;
	height: 46px;
	background: #fff;
	border: 1.5px solid #a8c8f0;
	border-radius: 10px;
}

.fa-audit-input-label {
	flex: 0 0 100px;
	font-size: 13px;
	font-weight: 700;
	color: #1a4a7a;
	white-space: nowrap;
}

.fa-audit-input {
	flex: 1;
	border: none;
	outline: none;
	font-size: 14px;
	font-weight: 600;
	color: #0a1e30;
	background: transparent;
}

.fa-audit-upload {
	display: flex;
	align-items: flex-start;
	gap: 12px;
}

.fa-audit-upload-label {
	flex: 0 0 100px;
	font-size: 13px;
	font-weight: 700;
	color: #1a4a7a;
	line-height: 80px;
}

.fa-audit-actions {
	display: flex;
	justify-content: center;
	gap: 60px;
	padding-top: 4px;
	border-top: 1px solid #dde9f5;
}

.fa-audit-voucher {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	padding: 12px 14px;
	background: #f4f9ff;
	border: 1px solid #dde9f5;
	border-radius: 10px;
}

.fa-audit-voucher-images {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}
</style>
